import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
//import { Http } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DirectDeskModule } from 'app/modules/desking/directdesk/directdesk.module';
import { CudlConnectComponent } from 'app/modules/desking/push/cudl-connect/cudl-connect.component';
import { CudlConnectService } from 'app/modules/desking/push/cudl-connect/cudl-connect.service';
import { PushToDealerTrackComponent } from 'app/modules/desking/push/dealer-track/dealer-track.component';
import { DealerTrackService } from 'app/modules/desking/push/dealer-track/dealer-track.service';
import { PushTradeLogService } from 'app/modules/desking/push/push-trade-log.service';
import { RouteOneComponent } from 'app/modules/desking/push/route-one/route-one.component';
import { RouteOneLogComponent } from 'app/modules/desking/push/route-one-log/route-one-log.component';
import { RouteOneService } from 'app/modules/desking/push/route-one/route-one.service';
import { RouteOneLogService } from 'app/modules/desking/push/route-one-log/route-one-log.service';
import { VAutoService } from 'app/modules/desking/trade-vehicles/pushes/vauto/vautoservice';
import { ERROR_HANDLER_CONFIG, ErrorHandlerConfig } from 'app/notifications/error-handler-config';
import { ErrorHandlerWithNotifications } from 'app/notifications/error-handler-with-notifications';
import { MessageType } from 'app/notifications/message';
import { NOTIFICATIONS_CONFIG, NotificationsConfig } from 'app/notifications/notifications-config';
import { NotificationsService } from 'app/notifications/notifications.service';
import { AuthInterceptor } from 'app/shared/auth.interceptor';

import { environment } from '../environments/environment';
import { AppLoadModule } from './app-load-module/app-load-module.module';
import { AppComponent } from './app.component';
import { ApplicationHttpClient, applicationHttpClientFactory } from './application-http-client';
import { CoreModule } from './core/core.module';
import { LoaderComponent } from './core/loader/loader.component';
import { DealershipService } from './modules/desking/dealership/dealsership.service';
import { PushToDmsComponent } from './modules/desking/push/push-to-dms/push-to-dms.component';
import { PushtoDmsServiceV1 } from './modules/desking/push/push-to-dms/push-to-dms.service';
import { LandingpageComponent } from './modules/landingpage/landingpage/landingpage.component';
import { ModulesModule } from './modules/modules.module';
import { PushtodmsService } from './modules/pushtodms/home/pushtodms.service';
import { GridService } from './modules/salesplanner/grid.service';
import { VehicleInfoService } from './modules/tradein/vehicle-info//vehicle-info.service';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { LoginService } from './pages/login/login.service';
import { XRMjwtStoreService } from './pages/login/xrmjwt-store.service';
import { PagesModule } from './pages/pages.module';
import { reducers } from './reducers';
import { AdminAuthguardService } from './shared/admin-authguard.service';
import { AuthguardService } from './shared/authguard.service';
import { LoaderService } from './shared/services/loader.service';
import { SharedModule } from './shared/shared.module';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const CustomErrorHandlerConfig: ErrorHandlerConfig = {
  showErrorInConsole: environment.showErrorInConsole,
  onErrorMessageType: MessageType.Toast
};

export const CustomNotificationsConfig: NotificationsConfig = {
  defaultTimeOut: 15000,
  closeable: true,
  closeAfterRouteChange: false
};

@NgModule({
  declarations: [
    AccessDeniedComponent,
    AppComponent,
    PushToDmsComponent,
    PushToDealerTrackComponent,
    CudlConnectComponent,
    RouteOneComponent,
    RouteOneLogComponent,
    LoaderComponent
  ],
  imports: [
    AppLoadModule,
    BrowserModule,
    BrowserAnimationsModule,
    StoreModule.forRoot(
      reducers, { runtimeChecks: { strictStateImmutability: false, strictActionImmutability: false }}
    ) /* Initialise the Central Store with Application's main reducer*/,
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 50 }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader
        
      }
    }),
    CoreModule,
    PagesModule,
    SharedModule.forRoot(),
    ModulesModule,
    DirectDeskModule
  ],
  providers: [
    LoaderService,
    AuthguardService,
    AdminAuthguardService,
    LoginService,
    GridService,
    VehicleInfoService,
    PushtodmsService,
    DealershipService,
    PushtoDmsServiceV1,
    DealerTrackService,
    CudlConnectService,
    RouteOneService,
    RouteOneLogService,
    PushTradeLogService,
    VAutoService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    XRMjwtStoreService,
    { provide: NOTIFICATIONS_CONFIG, useValue: CustomNotificationsConfig },
    NotificationsService,
    { provide: ERROR_HANDLER_CONFIG, useValue: CustomErrorHandlerConfig },
    { provide: ErrorHandler, useClass: ErrorHandlerWithNotifications },
    {
      provide: ApplicationHttpClient,
      useFactory: applicationHttpClientFactory,
      deps: [HttpClient, NotificationsService]
    }
  ],
  entryComponents: [PushToDmsComponent],
  bootstrap: [AppComponent]
})
export class AppModule {}
